import React, { createContext, useContext, useState } from "react";

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const showToast = ({ message, type = "success" }) => {
    const id = Date.now();

    const text =
      typeof message === "string"
        ? message
        : message?.message || JSON.stringify(message);

    setToasts((prev) => [...prev, { id, message: text, type }]);
    setTimeout(() => removeToast(id), 2500);
  };

  const removeToast = (id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  };

  const ToastContainer = () => (
    <div className="fixed top-4 left-1/2 -translate-x-1/2 z-50 space-y-2 pointer-events-none">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`
            w-full 
            sm:w-full 
            rounded-[4px]
            border-2
            px-2 
            md:px-4
            py-2
            bg-white shadow-lg
            font-medium text-[11px] sm:text-[16px] text-center
            pointer-events-auto
            animate-fadeInUp
            transition-all duration-300 ease-out
            ${toast.type === "success"
              ? "border-green-300 text-black"
              : toast.type === "error"
                ? "border-red-300 text-black"
                : "border-yellow-300 text-black"
            }
          `}
        >
          {toast.message}
        </div>
      ))}
    </div>
  );

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      <ToastContainer />
    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);
